import { render, staticRenderFns } from "./FileManagerPDF.vue?vue&type=template&id=ff0aab5a&scoped=true&"
import script from "./FileManagerPDF.vue?vue&type=script&lang=js&"
export * from "./FileManagerPDF.vue?vue&type=script&lang=js&"
import style0 from "./FileManagerPDF.vue?vue&type=style&index=0&id=ff0aab5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0aab5a",
  null
  
)

export default component.exports